import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { ImageStyledWrapper } from '@yme/atoms/image';
import { Link } from '@yme/components/Link';
import { colorCoreBlack900Base, colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { AspectRatio } from '@yme/utils/constants';
import { getTextStyles } from '@yme/utils/styles';
export const PartsAccessoriesStyled = styled.div `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;
`;
export const PreviewStyled = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100px;

  background-color: ${colorCoreWhite1000};

  aspect-ratio: ${AspectRatio.Square};

  ${({ isUrlExist }) => isUrlExist && `cursor: pointer;`}

  /* Extended styles for component Image */
  ${ImageStyledWrapper} {
    display: flex;
    align-items: center;
  }
`;
export const AccessoryNameStyled = styled.div `
  ${getTextStyles('Ubuntu', 500, 18, 28)}

  color: ${colorCoreBlack900Base};

  margin: 12px 0 4px 0;

  ${ADAPTIVE.maxWidth.mobile} {
    ${getTextStyles(null, null, 16, 24)}
  }
`;
export const ViewAllBottomStyled = styled(Button) `
  width: 100%;
`;
export const ItemAccessoryStyled = styled.div `
  position: relative;
  width: 100%;
  text-decoration: none;
  word-break: break-word;

  & > div:focus-visible {
    outline-offset: 1px;
  }
`;
